(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CreateUpdateCampaignTemplateViewModel', CreateUpdateCampaignTemplateViewModelFactory);

  /** @ngInject */
  function CreateUpdateCampaignTemplateViewModelFactory($translate, localeFilters, campaignTemplateActions, CampaignTemplateEnum) {
    function CreateUpdateCampaignTemplateViewModel(id) {
      this.id = id ? id : 0;
      this.title = '';
      this.isEditMode = this.id ? true : false;

      init.call(this);
    }

    CreateUpdateCampaignTemplateViewModel.prototype.destroy = function () {
    };

    CreateUpdateCampaignTemplateViewModel.prototype.removeRule = function (index) {
      this.rules.splice(index, 1);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByVisits = function () {
      var newRule = {
        id: 0,
        type: CampaignTemplateEnum.NUM_OF_VISITS
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByMoneySpent = function () {
      var newRule = {
        id: 0,
        type: CampaignTemplateEnum.MONEY_SPENT
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByDay = function () {
      var newRule = {
        id: 0,
        days: [],
        daysOfWeek: getDaysOfWeekArray(),
        type: CampaignTemplateEnum.DAILY_TEMPORAL
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.getDtoForPersistence = function () {
      var dtoResult = {
        id: this.id,
        name: this.name,
        numberOfVisits: [],
        amountOfMoney: [],
        dailyTemporal: []
      };

      this.rules.forEach(function (rule) {
        if (rule.type === CampaignTemplateEnum.NUM_OF_VISITS) {
          this.numberOfVisits.push({
            id: rule.id,
            visits: rule.visits,
            credits: rule.credits,
            validityPeriod: rule.validityPeriod
          });
        } else if (rule.type === CampaignTemplateEnum.MONEY_SPENT) {
          this.amountOfMoney.push({
            id: rule.id,
            money: rule.money,
            credits: rule.credits,
            validityPeriod: rule.validityPeriod
          });
        } else if (rule.type === CampaignTemplateEnum.DAILY_TEMPORAL) {
          this.dailyTemporal.push({
            id: rule.id,
            hoursFrom: rule.hoursFrom,
            minutesFrom: rule.minutesFrom,
            hoursTo: rule.hoursTo,
            minutesTo: rule.minutesTo,
            credits: rule.credits,
            days: rule.daysOfWeek.filter(function (dayOfWeek) {
              return dayOfWeek.selected;
            }).map(function (dayOfWeek) {
              return dayOfWeek.value;
            })
          });
        }
      }, dtoResult);

      return dtoResult;
    };

    return CreateUpdateCampaignTemplateViewModel;

    function init() {
      if (this.isEditMode) {
        this.title = $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE');
        refreshForExisting.call(this);
      } else {
        this.title = $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE');
        this.rules = [];
        this.addNewByDay();
        this.addNewByMoneySpent();
        this.addNewByVisits();
      }
    }

    function refreshForExisting() {
      var that = this;

      this.rules = [];

      campaignTemplateActions.getCampaignTemplateById(this.id).then(function (templateJson) {
        that.name = templateJson.name;

        templateJson.numberOfVisits.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.NUM_OF_VISITS;
          this.push(rule);
        }, that.rules);

        templateJson.amountOfMoney.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.MONEY_SPENT;
          this.push(rule);
        }, that.rules);

        templateJson.dailyTemporal.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
          rule.daysOfWeek = getDaysOfWeekArray();
          rule.days.forEach(function (dayIndex) {
            this[dayIndex].selected = true;
          }, rule.daysOfWeek);
          this.push(rule);
        }, that.rules);
      });
    }

    function getDaysOfWeekArray() {
      var daysOfWeek = [];
      for (var i = 0; i < 7; i++) {
        daysOfWeek.push({
          value: i,
          name: localeFilters.getDayLocale(i, true),
          selected: false
        });
      }
      return daysOfWeek;
    }
  }
})();
